import { AuthorizationPolicy } from '@microsoft/microsoft-graph-types-beta';
import { UserConsentWorkFlowSchema } from '../../../../../tools/schemas/graph/user-consent-policy.schema';
import { updateAuthorizationPolicy } from 'projects/angular-clarity/src/app/stores/client/graph/authorization-policy/actions';

export function Remediate(_tenant: string, _policy: AuthorizationPolicy, schema: UserConsentWorkFlowSchema) {
    return updateAuthorizationPolicy({
        _tenant,
        policy: {
            permissionGrantPolicyIdsAssignedToDefaultUserRole:
                schema.properties.permissionGrantPolicyIdsAssignedToDefaultUserRole.items.enum,
        },
    });
}
